<template>
  <v-flex xs12 sm10 md6 xl4>
    <div class="vertical-center-container">
      <v-select
        label="Select action"
        :items="actions"
        v-model="selectedAction"
        item-value="value"
        return-object
        prepend-inner-icon="list"
        clearable
        :clear-icon-cb="clearAction"
        :color="$store.state.global.pages.tipping.color"
      >
        <template
          slot="selection"
          slot-scope="data"
        >{{ selectedAction.dialog == 'match' ? 'Match Dockets' : !!selectedCount ? `${data.item.text} ${selectedCount} Tipping Dockets` : `${data.item.text}`}}</template>
      </v-select>
      <div>
        <v-btn
          :color="$store.state.global.pages[this.$route.name].color"
          flat
          @click="confirmAction()"
        >
          Confirm
          <!-- <v-icon right>save_alt</v-icon> -->
        </v-btn>
      </div>
    </div>

    <!-- EXPORT CSV DIALOG CONFIRMATION -->
    <v-dialog v-model="dialogs.csv" max-width="400px" @keydown.esc="dialogs.csv = false" lazy>
      <v-card>
        <v-card-title class="headline">
          <span>
            Export selected documents?
            <span class="grey--text subheading"></span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="dialogs.csv = false">Cancel</v-btn>
          <download-excel :fetch="tippingDockets" type="csv" name="tipping.csv">
            <v-btn
              :color="primaryNeutral"
              flat
              @click="dialog = false"
              :loading="loading"
            >Export Tipping Dockets</v-btn>
          </download-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.delete" max-width="400px" @keydown.esc="dialogs.delete = false" lazy>
      <confirmation-card
        title="Delete Selected Tipping Dockets"
        :subTitle="`This option will affect ${selectedCount} items`"
      >
        <v-btn color="grey darken-1" flat @click="dialogs.delete = false">Cancel</v-btn>
        <v-btn color="red" flat @click="deleteItems()" :loading="loading">Delete Tipping Dockets</v-btn>
      </confirmation-card>
    </v-dialog>

    <v-dialog v-model="dialogs.match" max-width="550px" @keydown.esc="dialogs.match = false" lazy>
      <confirmation-card
        title="Match with Dockets/Trips"
        :subTitle="`This option will attempt to match all (${!!count ? count : 0}) unmatched tipping dockets. This may slow the system down for up to a minute.`"
      >
        <v-btn color="grey darken-1" flat @click="dialogs.match = false">Cancel</v-btn>
        <v-btn :color="primaryNeutral" flat @click="matchDockets()" :loading="loading">Match Dockets</v-btn>
      </confirmation-card>
    </v-dialog>

    <v-dialog v-model="dialogs.status" max-width="400px" @keydown.esc="dialogs.status = false" lazy>
      <update-status
        :selected="selected"
        :selectedAll="selectedAll"
        :selectedCount="selectedCount"
        @close="dialogs.status = false"
        :dialog="dialogs.status"
      ></update-status>
    </v-dialog>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import TippingService from '@/services/requests/tippingService'
import BuildTippingQuery from '../mixins/buildTippingQuery'
import DownloadExcel from 'vue-json-excel'
import FormatDates from '@/services/mixins/formatDates'
import UpdateStatus from '@/modules/tipping/components/updateStatus'

export default {
  mixins: [BuildTippingQuery, FormatDates],
  data() {
    return {
      actions: [
        {
          text: 'Update status',
          icon: 'info',
          color: 'green lighten-2',
          dialog: 'status'
        },
        {
          text: 'Match dockets',
          icon: this.$store.state.global.pages.docket.icon,
          color: 'grey',
          dialog: 'match'
        },
        {
          text: 'Delete',
          icon: 'delete',
          color: 'red lighten 4',
          dialog: 'delete'
        },
        {
          text: 'Export CSV',
          icon: 'delete',
          color: 'red lighten 4',
          dialog: 'csv'
        }
      ],
      selectedAction: {},
      dialogs: {
        csv: false,
        delete: false,
        status: false,
        match: false
      },
      loading: false,
      count: null
    }
  },
  methods: {
    clearAction() {
      this.selectedAction = {}
    },
    confirmAction() {
      if (!this.selectedCount && this.selectedAction.dialog != 'match') {
        this.snack({
          color: 'yellow',
          text: 'No Tipping Dockets are selected!'
        })
        this.dialog = false
        return
      }
      if (!Object.keys(this.selectedAction).length) {
        this.snack({ color: 'yellow', text: 'No action was selected!' })
        this.dialog = false
        return
      } else {
        this.dialogs[this.selectedAction.dialog] = true
      }
    },
    async tippingDockets() {
      this.loading = true
      var lines = await this.getTippingDockets()
      lines = lines.map(line => {
        return {
          ID: line.id,
          ExternalRef: line.tippingDocketHeader.externalRef,
          Date: line.tippingDocketHeader.date,
          Status: line.status,
          Project: !!line.tippingDocketHeader.project
            ? line.tippingDocketHeader.project.name
            : '',
          'W/B Docket #': line.wbDocketNumber,
          Spoil: line.spoil.name,
          TipName: line.tippingDocketHeader.tip.name,
          TipTSE: line.tippingDocketHeader.tip.number,
          SubContractor: !!line.tippingDocketHeader.vehicle.contractor
            ? line.tippingDocketHeader.vehicle.contractor.name
            : '-',
          Vehicle: line.tippingDocketHeader.vehicle.name,
          VehicleType: line.tippingDocketHeader.vehicle.vehicleType.name,
          Vin: line.tippingDocketHeader.vehicle.vin,
          Qty: line.qty,
          CostPrice: line.costPrice.toFixed(2),
          CostTotal: line.costTotal.toFixed(2),
          TimeOfDay: line.tippingDocketHeader.isDay ? 'Day' : 'Night',
          Notes: line.notes,
          CreatedAt: this.makeShortDate(line.createdAt),
          UpdatedAt: this.makeShortDate(line.updatedAt),
          CreatedBy: line.createdBy.name,
          UpdatedBy: line.updatedBy.name
        }
      })
      this.loading = false
      this.dialogs.csv = false
      return lines
    },
    async getTippingDockets() {
      if (this.selectedAll) {
        return await this.retrieveTippingDockets()
      } else {
        return this.selected
      }
    },
    async retrieveTippingDockets() {
      var payload = this.buildQuery()
      payload.pagination = this.pagination
      payload.csv = true
      this.loading = true
      try {
        var result = await TippingService.getTippingDockets(payload)
        return result.data.result
      } catch (err) {
        return []
      }
    },
    matchDockets() {
      this.loading = true
      TippingService.matchDockets()
        .then(result => {
          this.loading = false
          this.dialogs.match = false
          this.$store.state.tipping.fetchTippingDockets = true
          this.snack({ text: result.data.message, color: 'green' })
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.snack({ text: err.response.data.message, color: 'red' })
        })
    },
    async deleteItems() {
      this.loading = true
      var payload = {}
      if (this.selectedAll) {
        payload = this.buildQuery()
        payload.pagination = this.pagination
      } else {
        payload.ids = this.selected.map(item => {
          return item.id
        })
      }
      try {
        var deleted = await TippingService.deleteMultipleTippingDockets(payload)
        this.snack({ text: deleted.data.message, color: 'green' })
        this.$store.state.tipping.fetchTippingDockets = true
        this.dialogs.delete = false
        this.selected = []
      } catch (err) {
        this.snack({ text: err.response.data.message, color: 'red' })
      }
      this.loading = false
    },
    countMatchLines() {
      TippingService.countMatchLines()
        .then(result => {
          console.log(result)
          this.count = result.data.result
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  computed: {
    selected: Store.getSet({ store: 'tipping', prop: 'selected' })
  },
  props: {
    //selected: Array,
    selectedCount: Number,
    selectedAll: Boolean,
    pagination: Object
  },
  watch: {
    'dialogs.match': function(val) {
      if (val) this.countMatchLines()
    }
  },
  components: {
    DownloadExcel,
    UpdateStatus
  }
}
</script>
